import { styled, Button } from '@mui/material'

export const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: 10,
  minHeight: 'auto',
  fontSize: '0.875rem',
  fontWeight: '400',
  lineHeight: '1.5rem',
  padding: theme.spacing(0.75, 1),
  textDecoration: 'underline',
}))
